import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "../../../components/Form/Form";
import FormTitle from "../../../components/FormTitle/FormTitle";
import Input from "../../../components/Input/Input";
import Loader from "../../../components/Loader/Loader";
import { useAuth } from "../../../contexts/auth";
import { useListManager } from "../../../contexts/list.manager";
import removeMask from "../../../functions/RemoveMask";
import OperadorService from "../../../services/OperadorService";
import "./FormOperadores.css";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import { LevelSelector } from "../../../components/LevelSelector/LevelSelector";
import { ShiftSelector } from "../../../components/ShiftSelector/ShiftSelector";
import { LuUser } from "react-icons/lu";
import { IoAlertCircleOutline } from "react-icons/io5";

function FormOperadores(props) {
	const { user } = useAuth();
	const [nome, setNome] = useState(props.operador?.name);
	const [cpf, setCpf] = useState(props.operador?.document);
	const [email, setEmail] = useState(props.operador?.email);
	const [telefone, setTelefone] = useState(props.operador?.phone);
	const [turno, setTurno] = useState(props.operador?.shift);
	const [hasRootAccess, setHasRootAcess] = useState(props.operator?.hasRootAccess);
	const [levels, setLevels] = useState([]);
	const [showLoader, setShowLoader] = useState(false);
	const [turnos, setTurnos] = useState([]);
	const { closeForm } = useListManager();

	useEffect(() => {
		setNome(props.operador?.name);
		setCpf(props.operador?.document);
		setEmail(props.operador?.email);
		setTelefone(props.operador?.phone);
		setTurno(props.operador?.shift?.id);
		setHasRootAcess(props.operador?.hasRootAccess);
		setLevels(props.operador?.authorityLevels?.map(level => ({ unitId: level.unitId, hierarchy: level.hierarchy })) || []);
		loadShifts();
	}, [props.operador]);

	const navigate = useNavigate();

	async function loadShifts() {
		if (!props.operador) return;
		const response = await OperadorService.getPersonShifts(props.operador.id);
		if (!response?.data) return;

		const shifts = response.data;
		setTurnos(shifts);
	}

	const buildPayload = () => {
		const payload = {
			organizationsIds: user.userData.selectedOrganizationId,
			name: nome,
			document: removeMask(cpf),
			email: email,
			phone: telefone ? removeMask(telefone) : null,
			levels: levels?.map(level => ({ ...level, hierarchy: level.hierarchy || false })) || [],
			hasRootAccess,
			shifts: turnos.filter(shift => !shift.new && !shift.editing),
		};

		if (props.type === "cadastro" && props.role) {
			payload.roleExternalId = props.role.externalId;
		}

		return payload;
	};

	function onShiftsChange(shifts) {
		setTurnos(shifts);
	}

	async function handleSubmit(event) {
		event.preventDefault();
		setShowLoader(true);

		const payload = buildPayload();
		let response = {};

		if (props.type === "edicao") {
			response = await OperadorService.updateOperador(
				props.operador.id,
				payload
			);
		} else if (props.type === "cadastro") {
			response = await OperadorService.createOperador(payload);
		}

		setShowLoader(false);

		if (!response?.data?.id) return;
		navigate("../consulta-operadores", {
			state: { refresh: true }
		});
	}

	const handleClickEditButton = () => {
		if (!props.operador) return;
		navigate(`/pessoa/${props.operador.id}`, { state: props.operador });
	};

	async function handleDelete() {
		setShowLoader(true);
		if (!props.operador) return;
		await OperadorService.deleteOperador(props.operador.id);
		navigate("../consulta-operadores", {
			state: { deletedId: props.operador.id },
		});
		setShowLoader(false);
		closeForm();
	}

	return (
		<React.Fragment>
			<FormTitle
				type={props.type}
				icon={<LuUser size={20} />}
				tituloConsulta={props.operador?.name || null}
				tituloCadastro="Cadastro de Pessoa"
				backRoute={"/consulta-operadores"}
			/>
			{showLoader ? (
				<Loader />
			) : (
				<Form
					handleSubmit={handleSubmit}
					type={props.type}
					handleClickEdit={handleClickEditButton}
					handleDelete={handleDelete}
					navigateCancelUrl="../consulta-operadores"
				>
					{props.role && (
						<div className='alert alert-warning items-center!'>
							<IoAlertCircleOutline size={20} />
							Você está cadastrando uma pessoa com o perfil de <span className="font-bold">{props.role.name}</span>
							<Link to={`../papeis/${props.role.externalId}`}>Ver permissões</Link>
						</div>
					)}
					<div className="operator-form-grid">
						<div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
							<div className="form-row-operator">
								<Input
									name="name"
									id="name"
									labelText="Nome da Pessoa *"
									value={nome}
									onChange={({ target }) => setNome(target.value)}
									disabled={props.type === "consulta"}
									required={true}
									tooltipText="Nome Completo da pessoa"
									tooltipVisible={true}
								/>
								<Input
									name={"cpf"}
									id="cpf"
									labelText={"CPF *"}
									value={cpf}
									onChange={({ target }) => setCpf(target.value)}
									required={true}
									disabled={props.type === "consulta"}
									minlength={"14"}
									maxlength={"14"}
									showCpfMask={true}
									placeholder="000.000.000-00"
									tooltipText="CPF da pessoa"
									tooltipVisible={true}
								/>
							</div>
							<div className="form-row-operator">
								<Input
									name={"mail"}
									id="mail"
									labelText={"E-mail *"}
									value={email}
									onChange={({ target }) => setEmail(target.value)}
									required={true}
									disabled={props.type === "consulta"}
									placeholder="exemplo@email.com"
									tooltipText="E-mail de acesso do operador"
									tooltipVisible={true}
								/>
								<Input
									name={"phone_number"}
									id="phone_number"
									labelText={"Telefone"}
									value={telefone}
									onChange={({ target }) => setTelefone(target.value)}
									hidden={props.type === "consulta"}
									placeholder="(00) 00000-0000"
									showPhoneMask={true}
									minlength={"15"}
									maxlength={"15"}
									tooltipText="Telefone de contato da pessoa"
									tooltipVisible={true}
								/>
							</div>
							{(props.type !== "consulta" && !user.userData.selectedOrganizationId && (user.userData.isSuperAdmin || user.userData.hasRootAccess)) && (
								<div className="form-row-operator">
									<ToggleButton
										style={{ justifyContent: 'start' }}
										label={`${hasRootAccess
											? "Acesso Root Bravas Habilitado"
											: "Acesso Root Bravas Desabilitado"
											}`}
										selected={hasRootAccess}
										onClick={() => setHasRootAcess(!hasRootAccess)}
										disabled={props.type === "consulta"}
										tooltipVisible={true}
										tooltipText={
											"Habilita ou desabilita o acesso root da bravas, com essa opção marcada a pessoa será identificado como integrante da Bravas."
										}
									/>
								</div>
							)}
						</div>
						{props.type !== "consulta" && (
							<div className="form-row-operator">
								{!hasRootAccess && (
									<ShiftSelector shifts={turnos} onChange={onShiftsChange} />
								)}
								<LevelSelector
									onChange={(levels) => {
										setLevels(levels.map(level => ({
											unitId: level.unitId,
											hierarchy: level.childrenAuthorized
										})));
									}}
									levels={levels.map(level => ({
										unitId: level.unitId,
										childrenAuthorized: level.hierarchy
									}))}
									showRoot={false}
									type={props.type}
									title={"Níveis de Acesso Cloud"}
									description={"Selecione os níveis de acesso da pessoa na hierarquia da organização."}
								/>
							</div>
						)}
					</div>
				</Form>
			)}
		</React.Fragment>
	);
}

export default FormOperadores;
